export default __webpack_public_path__ + "images/KM.2ed0502.png";